export type RecentEntityType = 'task' | 'client' | 'user' | 'website' | 'proposal';

export interface RecentItem {
  type: RecentEntityType;
  id: string;
  name: string;
  secondary?: string;
  viewedAt: number;
}

export const RECENTS_STORAGE_KEY = 'cmdk:recents';

export function readRecents(): RecentItem[] {
  try {
    const raw = window.localStorage.getItem(RECENTS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as RecentItem[];
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((item) => item && item.type && item.id && item.name)
      .sort((a, b) => b.viewedAt - a.viewedAt)
      .slice(0, 10);
  } catch {
    return [];
  }
}

export function pushRecent(item: Omit<RecentItem, 'viewedAt'>): RecentItem[] {
  const viewedAt = Date.now();
  const next = [
    { ...item, viewedAt },
    ...readRecents().filter((recent) => !(recent.type === item.type && recent.id === item.id)),
  ].slice(0, 10);
  window.localStorage.setItem(RECENTS_STORAGE_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent('cmdk:recents-updated'));
  return next;
}
